module.exports = __webpack_public_path__ + "img/cg_awaken.27bcd34b.jpg";